<div class="confirmation-popup">
  <div class="confirmation-popup__header">
    <h2 class="confirmation-popup__title">{{ data.title }}</h2>
    <button class="confirmation-popup__close" type="button" (click)="onClose()">
      <ptl-icon [icon]="Cancel01Icon" size="m"></ptl-icon>
    </button>
  </div>

  <p class="confirmation-popup__message">{{ data.message }}</p>

  <div class="confirmation-popup__separator"></div>

  <div class="confirmation-popup__actions">
    <ptl-button
      [type]="data.cancelButtonType || 'secondary-neutral'"
      size="l"
      [text]="data.cancelButtonText"
      [fullWidth]="true"
      (clicked)="onCancel()"
    ></ptl-button>
    <ptl-button
      [type]="data.confirmButtonType || 'primary'"
      size="l"
      [text]="data.confirmButtonText"
      [fullWidth]="true"
      (clicked)="onConfirm()"
    ></ptl-button>
  </div>
</div>
